export enum RELEASE_TYPE {
  unknown = -1,
  single = 1,
  album = 2,
  minialbum = 3,
}

export enum SUBSCRIPTION_TYPE {
  unknown = -1,
  all = 1,
  ad = 2,
  subscription = 3,
}
// export enum DELIVERY_STATUS {
//   unknown = -1,
//   notSend = 0,
//   waiting = 1,
//   inProgress = 2,
//   done = 3,
//   error = 4,
//   canceled = 5,
//   updateWaiting = 6,
//   withdrawWaiting = 7,
//   publishWaiting = 8,
//   published = 9,
//   waitingForAssetIds = 10,
//   inProgressAssigningAssetIds = 11,
//   errorAssigningAssetIds = 12,
//   doneAssigningAssetIds = 13,
//   withdrawInProgress = 15,
//   withdrawDone = 16,
//   withdrawError = 17,
//   unavailable = 18,
// }
export enum DELIVERY_STATUS {
  unknown = -1,
  notSend = 0,
  waiting = 1,
  inProgress = 2,
  published = 3,
  error = 4,
  canceled = 5,

  waitingForACKFile = 6,
  inProgressProcessingACKFile = 7,
  errorProcessingACKFile = 8,
  ACKFileError = 9,

  waitingForAssetIds = 10,
  inProgressAssigningAssetIds = 11,
  errorAssigningAssetIds = 12,

  withdrawWaiting = 13,
  withdrawInProgress = 14,
  withdrawn = 15,
  withdrawError = 16,

  unavailable = 17,
  publishWaiting = 18,
}

export enum DIGITAL_PRODUCT_TYPE {
  unknown = -1,
  audio = 1,
  video = 2,
}
